"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createServerStreamingMethod = void 0;
const grpc_web_1 = require("@improbable-eng/grpc-web");
const abort_controller_x_1 = require("abort-controller-x");
const AsyncSink_1 = require("../utils/AsyncSink");
const nice_grpc_common_1 = require("nice-grpc-common");
const node_abort_controller_1 = __importDefault(require("node-abort-controller"));
const service_definitions_1 = require("../service-definitions");
const convertMetadata_1 = require("../utils/convertMetadata");
const isAsyncIterable_1 = require("../utils/isAsyncIterable");
/** @internal */
function createServerStreamingMethod(definition, channel, middleware, defaultOptions) {
    const grpcMethodDefinition = (0, service_definitions_1.toGrpcWebMethodDefinition)(definition);
    const methodDescriptor = {
        path: definition.path,
        requestStream: definition.requestStream,
        responseStream: definition.responseStream,
        options: definition.options,
    };
    async function* serverStreamingMethod(request, options) {
        if ((0, isAsyncIterable_1.isAsyncIterable)(request)) {
            throw new Error('A middleware passed invalid request to next(): expected a single message for server streaming method');
        }
        const { metadata = (0, nice_grpc_common_1.Metadata)(), signal = new node_abort_controller_1.default().signal, onHeader, onTrailer, } = options;
        const sink = new AsyncSink_1.AsyncSink();
        const client = grpc_web_1.grpc.client(grpcMethodDefinition, {
            host: channel.address,
            transport: channel.transport,
        });
        client.onHeaders(headers => {
            onHeader === null || onHeader === void 0 ? void 0 : onHeader((0, convertMetadata_1.convertMetadataFromGrpcWeb)(headers));
        });
        client.onMessage(message => {
            sink.write(message);
        });
        client.onEnd((code, message, trailers) => {
            onTrailer === null || onTrailer === void 0 ? void 0 : onTrailer((0, convertMetadata_1.convertMetadataFromGrpcWeb)(trailers));
            if (code === grpc_web_1.grpc.Code.OK) {
                sink.end();
            }
            else {
                sink.error(new nice_grpc_common_1.ClientError(definition.path, +code, message));
            }
        });
        client.start((0, convertMetadata_1.convertMetadataToGrpcWeb)(metadata));
        client.send({
            serializeBinary: () => definition.requestSerialize(request),
        });
        client.finishSend();
        const abortListener = () => {
            sink.error(new abort_controller_x_1.AbortError());
            client.close();
        };
        signal.addEventListener('abort', abortListener);
        try {
            yield* sink;
        }
        finally {
            signal.removeEventListener('abort', abortListener);
            (0, abort_controller_x_1.throwIfAborted)(signal);
        }
    }
    const method = middleware == null
        ? serverStreamingMethod
        : (request, options) => middleware({
            method: methodDescriptor,
            requestStream: false,
            request,
            responseStream: true,
            next: serverStreamingMethod,
        }, options);
    return (request, options) => {
        const iterable = method(request, {
            ...defaultOptions,
            ...options,
        });
        const iterator = iterable[Symbol.asyncIterator]();
        return {
            [Symbol.asyncIterator]() {
                return {
                    async next() {
                        const result = await iterator.next();
                        if (result.done && result.value != null) {
                            return await iterator.throw(new Error('A middleware returned a message, but expected to return void for server streaming method'));
                        }
                        return result;
                    },
                    return() {
                        return iterator.return();
                    },
                    throw(err) {
                        return iterator.throw(err);
                    },
                };
            },
        };
    };
}
exports.createServerStreamingMethod = createServerStreamingMethod;
//# sourceMappingURL=createServerStreamingMethod.js.map